import { useEffect, useRef } from "react";
import { Mixpanel } from "lib/mixpanel/mixpanel";
import { useRouter } from "next/router";

import type { PodcastsPageData } from "lib/types/podcasts";
import type { Podcast as PodcastType } from "lib/types/podcasts";
import { MIXPANEL_TOKEN } from "lib/constants";
import { useUserData } from "lib/store/user";

import { Hero } from "./components/hero/hero";
import { Podcast } from "./components/podcast/podcast";

export type PodcastsViewProps = PodcastsPageData;

export const PodcastsView = ({
  title,
  description,
  list,
}: PodcastsViewProps) => {
  const { userId } = useUserData();
  const mixpanelRef = useRef<Mixpanel | null>(null);
  const router = useRouter();

  useEffect(() => {
    mixpanelRef.current = new Mixpanel(MIXPANEL_TOKEN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPodcastCTAClick = async (podcast: PodcastType) => {
    if (userId && mixpanelRef.current) {
      mixpanelRef.current.track("Podcasts CTA click", {
        distinct_id: userId,
        "Click link": podcast.link,
        "Click text": podcast.name,
        "Page path": router.asPath,
      });
    }
  };
  return (
    <main data-page-type="podcasts">
      <div className="wrapper relative overflow-hidden max-lg:min-h-[calc(100vh_-_278.5px)] max-md:px-[30px]">
        <div className="mt-16 flex flex-col pb-4xl md:mt-32 lg:mx-auto lg:w-5/6 lg:max-w-[878px] lg:pb-4xl">
          <div className="mb-12 w-100 md:mb-8 md:max-w-[672px] lg:mb-12 lg:max-w-[80%]">
            <Hero title={title} description={description} />
          </div>
          {list.length > 0 && (
            <ul
              aria-label={"List of Podcasts by Sifted"}
              className="mb-4 flex w-100 flex-col gap-[48px] md:mb-[44px] md:gap-[44px]"
            >
              {list.map((el) => {
                return (
                  <li key={el.id}>
                    <Podcast {...el} onLinkClick={onPodcastCTAClick} />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </main>
  );
};
